/**
 * @generated SignedSource<<cf7cac1f78c551199271dc38cc2e4ae9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InsightMetricFilterField = "KpiAbsent" | "KpiPresent" | "LabelLift" | "NumberOfAdsAbsent" | "NumberOfAdsPresent" | "SpendAbsent" | "SpendPresent" | "%future added value";
export type InsightV2OrderBy = "AD_SPEND_ABSENT_ASC" | "AD_SPEND_ABSENT_DESC" | "AD_SPEND_PRESENT_ASC" | "AD_SPEND_PRESENT_DESC" | "COUNT_ABSENT_ASC" | "COUNT_ABSENT_DESC" | "COUNT_PRESENT_ASC" | "COUNT_PRESENT_DESC" | "DELTA_ASC" | "DELTA_DESC" | "LABEL_LIFT_ASC" | "LABEL_LIFT_DESC" | "LABEL_NAME_ASC" | "LABEL_NAME_DESC" | "LABEL_TYPE_ASC" | "LABEL_TYPE_DESC" | "RATE_WHEN_ABSENT_ASC" | "RATE_WHEN_ABSENT_DESC" | "RATE_WHEN_PRESENT_ASC" | "RATE_WHEN_PRESENT_DESC" | "%future added value";
export type KPI = "AGGREGATE_CONVERSION_RATE" | "AVG_DAILY_PURCHASE_VOLUME" | "AVG_DAILY_SPEND" | "CLICK_THROUGH_RATE" | "CONVERSION_RATE" | "COST_PER_ADD_TO_CART" | "COST_PER_COMPLETED_REGISTRATION" | "COST_PER_DONATION" | "COST_PER_ENGAGEMENT" | "COST_PER_INITIATED_CHECKOUT" | "COST_PER_INSTALL" | "COST_PER_LANDING_PAGE_VIEW" | "COST_PER_LEAD" | "COST_PER_LINK_CLICK" | "COST_PER_PURCHASE" | "COST_PER_STORE_LOCATOR" | "COST_PER_TOTAL_PURCHASE" | "COST_PER_TRIAL_STARTED" | "CPM" | "ENGAGEMENT_RATE" | "HOOK_RATE" | "IMPRESSIONS" | "LANDING_PAGE_VIEW_RATE" | "LEAD_CONVERSION_RATE" | "LEAD_RATE" | "PURCHASES" | "PURCHASES_CONVERSION" | "PURCHASES_TO_IMPRESSIONS" | "PURCHASES_TO_LINK_CLICK" | "PURCHASES_TO_LPV" | "REACH" | "RESULT_RATE" | "ROAS" | "SPEND" | "TOTAL_ROAS" | "TRIALS_STARTED" | "TRIALS_STARTED_TO_IMPRESSIONS" | "WEBSITE_PURCHASES" | "%future added value";
export type LabelType = "DOMINANT_COLOR" | "HEADLINE" | "HOOK_TEXT" | "IMAGE" | "NOUN" | "PHRASE" | "TAG" | "THEME" | "VERB" | "VIDEO" | "%future added value";
export type MetricFilterOperator = "EQ" | "GT" | "GTE" | "LT" | "LTE" | "NE" | "%future added value";
export type ListInsightV2Request = {
  filter: InsightV2Filter;
  orderBy?: InsightV2OrderBy | null;
  pagination?: PaginationInput | null;
};
export type PaginationInput = {
  skip?: number | null;
  take?: number | null;
};
export type InsightV2Filter = {
  brandId: string;
  delta_gt?: number | null;
  delta_lt?: number | null;
  includeAllDates?: boolean | null;
  kpi: KPI;
  labelTypes: ReadonlyArray<LabelType>;
  metrics?: ReadonlyArray<InsightMetricFilter> | null;
  performanceDateRange?: DateRangeInput | null;
  searchQueries?: ReadonlyArray<SearchQuery> | null;
};
export type SearchQuery = {
  fieldKey: string;
  type: string;
  value: string;
};
export type DateRangeInput = {
  end: string;
  start: string;
};
export type InsightMetricFilter = {
  fieldKey: InsightMetricFilterField;
  operator: MetricFilterOperator;
  value: number;
};
export type HookTextsQuery$variables = {
  input: ListInsightV2Request;
};
export type HookTextsQuery$data = {
  readonly hookTexts: {
    readonly count: number;
    readonly data: ReadonlyArray<{
      readonly id: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"HookText_InsightV2">;
    }>;
    readonly metadata: {
      readonly dateRange: {
        readonly end: any;
        readonly start: any;
      } | null;
    };
    readonly pageInfo: {
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
    };
  };
};
export type HookTextsQuery = {
  response: HookTextsQuery$data;
  variables: HookTextsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPreviousPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "InsightV2Metadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DateRange",
      "kind": "LinkedField",
      "name": "dateRange",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HookTextsQuery",
    "selections": [
      {
        "alias": "hookTexts",
        "args": (v1/*: any*/),
        "concreteType": "InsightV2List",
        "kind": "LinkedField",
        "name": "listInsightV2",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InsightV2",
            "kind": "LinkedField",
            "name": "data",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "HookText_InsightV2"
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HookTextsQuery",
    "selections": [
      {
        "alias": "hookTexts",
        "args": (v1/*: any*/),
        "concreteType": "InsightV2List",
        "kind": "LinkedField",
        "name": "listInsightV2",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InsightV2",
            "kind": "LinkedField",
            "name": "data",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "labelName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "delta",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contentUrls",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "KPI",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a8e3af62e13516547aed90d801bc0489",
    "id": null,
    "metadata": {},
    "name": "HookTextsQuery",
    "operationKind": "query",
    "text": "query HookTextsQuery(\n  $input: ListInsightV2Request!\n) {\n  hookTexts: listInsightV2(input: $input) {\n    count\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n    }\n    data {\n      id\n      ...HookText_InsightV2\n    }\n    metadata {\n      dateRange {\n        start\n        end\n      }\n    }\n  }\n}\n\nfragment HookText_InsightV2 on InsightV2 {\n  id\n  labelName\n  delta\n  contentUrls\n  KPI\n}\n"
  }
};
})();

(node as any).hash = "bc5cbf5bbf172342bff0e5dc4b995daf";

export default node;
